/**
 * RETOBLOCK TOP NAVIGATION BAR COMPONENT
 * Quản lý Menu File/Edit, Tên dự án inline edit, Nút Monitor, BLE Pill và Cụm Run/Stop.
 */

import { supabaseService } from '../core/supabase-client.js';

function getRetozoneUrl() {
  if (import.meta.env?.VITE_RETOZONE_PORTAL_URL) {
    return import.meta.env.VITE_RETOZONE_PORTAL_URL;
  }
  if (import.meta.env?.VITE_RETOZONE_URL) {
    return import.meta.env.VITE_RETOZONE_URL;
  }
  if (typeof window !== 'undefined') {
    const host = window.location.hostname;
    if (host.includes('retobots.vn')) {
      return 'https://stage.retobots.vn';
    }
  }
  return 'https://stage.retobots.vn';
}

function getRetolearnUrl() {
  if (import.meta.env?.VITE_RETOLEARN_URL) {
    return import.meta.env.VITE_RETOLEARN_URL;
  }
  if (typeof window !== 'undefined') {
    const host = window.location.hostname;
    if (host.includes('retobots.vn')) {
      return 'https://stage-retolearn.retobots.vn';
    }
  }
  return 'https://stage-retolearn.retobots.vn';
}

export class TopNavbar {
  constructor(options) {
    this.container = options.container;
    this.projectManager = options.projectManager;
    this.bleTransport = options.bleTransport;
    this.onRun = options.onRun;
    this.onStop = options.onStop;
    this.onOpenMonitor = options.onOpenMonitor;
    this.onOpenPythonView = options.onOpenPythonView;
    this.onOpenBleModal = options.onOpenBleModal;
    this.onNewProject = options.onNewProject;
    this.onOpenProject = options.onOpenProject;
    this.onSaveProject = options.onSaveProject;
    this.onOpenCloud = options.onOpenCloud;
    this.onOpenOta = options.onOpenOta;
    this.onOpenPythonGuide = options.onOpenPythonGuide;
    this.currentUser = null;

    this.init();
  }

  init() {
    this.container.innerHTML = `
      <div class="top-navbar" id="top-navbar">
        <!-- LEFT: Brand & Menus -->
        <div class="nav-left">
          <div class="nav-brand" id="brand-logo-btn" title="RETOCODE Studio">
            <img src="/assets/logo-retocode.png" alt="RETOCODE" class="brand-logo-img" />
            <span class="brand-badge">Studio</span>
          </div>

          <div class="nav-menu">
            <!-- File Menu -->
            <div class="menu-item" id="menu-file">
              <button class="menu-btn" id="btn-menu-file">Tệp <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="m6 9 6 6 6-6"/></svg></button>
              <div class="dropdown-menu" id="dropdown-file">
                <div class="dropdown-item" id="menu-item-new">
                  <span>Dự án mới...</span>
                  <span class="shortcut">Ctrl+N</span>
                </div>
                <div class="dropdown-item" id="menu-item-open">
                  <span>Mở từ máy tính (.reto)...</span>
                  <span class="shortcut">Ctrl+O</span>
                </div>
                <div class="dropdown-divider"></div>
                <div class="dropdown-item" id="menu-item-save">
                  <span>Lưu về máy tính (.reto)</span>
                  <span class="shortcut">Ctrl+S</span>
                </div>
              </div>
            </div>

            <!-- Edit Menu -->
            <div class="menu-item" id="menu-edit">
              <button class="menu-btn" id="btn-menu-edit">Chỉnh sửa <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="m6 9 6 6 6-6"/></svg></button>
              <div class="dropdown-menu" id="dropdown-edit">
                <div class="dropdown-item" id="menu-item-format">
                  <span>Định dạng mã nguồn</span>
                </div>
                <div class="dropdown-item" id="menu-item-clear">
                  <span>Xóa trắng vùng làm việc</span>
                </div>
              </div>
            </div>

            <!-- Help Menu -->
            <div class="menu-item" id="menu-help">
              <button class="menu-btn" id="btn-menu-help">Trợ giúp <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="m6 9 6 6 6-6"/></svg></button>
              <div class="dropdown-menu" id="dropdown-help">
                <div class="dropdown-item" id="menu-item-help-python-guide">
                  <span style="display: inline-flex; align-items: center; gap: 8px;">
                    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#38BDF8" stroke-width="2"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/><polyline points="10 9 9 9 8 9"/></svg>
                    <span>Hướng dẫn lập trình Python</span>
                  </span>
                  <span class="shortcut">F1</span>
                </div>
                <div class="dropdown-divider"></div>
                <div class="dropdown-item" id="menu-item-help-about">
                  <span>Về RETOLOGIX Studio v1.0</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- CENTER: Project Title & Mode -->
        <div class="nav-center">
          <div class="project-name-wrapper" id="project-name-box" title="Bấm để đổi tên dự án">
            <span class="unsaved-dot" id="unsaved-dot"></span>
            <span class="project-name-text" id="project-name-text">Du_An_Robot_1</span>
            <input type="text" class="project-name-input" id="project-name-input" maxlength="40" />
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" opacity="0.7"><path d="M17 3a2.85 2.83 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5Z"/></svg>
          </div>
          <span class="mode-badge scratch" id="mode-badge">SCRATCH</span>
        </div>

        <!-- RIGHT: Tools & Action Buttons -->
        <div class="nav-right">
          <!-- BLE Pill Button -->
          <button class="ble-pill-btn disconnected" id="btn-ble-status" title="Quản lý kết nối Bluetooth BLE">
            <svg id="ble-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="m7 7 10 10-5 5V2l5 5L7 17"/></svg>
            <span id="ble-text">Chưa kết nối</span>
          </button>

          <!-- Run / Stop Controls -->
          <div class="run-stop-group">
            <button class="btn-run" id="btn-run-code" title="Biên dịch và nạp code xuống robot (Live Mode)">
              <svg id="run-icon" width="16" height="16" viewBox="0 0 24 24" fill="currentColor"><polygon points="5 3 19 12 5 21 5 3"/></svg>
              <span id="run-text">
                <span class="run-text-full">RUN CODE</span>
                <span class="run-text-short">RUN</span>
              </span>
            </button>
            <button class="btn-stop" id="btn-stop-code" title="DỪNG KHẨN CẤP (Phanh động cơ & tắt còi tức thì)">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor"><rect width="18" height="18" x="3" y="3" rx="2"/></svg>
            </button>
          </div>

          <!-- User Profile Dropdown Pill -->
          <div class="profile-dropdown-wrapper" id="profile-dropdown-wrapper">
            <button class="profile-pill-btn offline" id="btn-profile-trigger" type="button" title="Đăng nhập tài khoản RETOBOTS">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>
              <span class="profile-pill-name" id="profile-pill-name">Đăng nhập</span>
            </button>
            <div class="profile-dropdown-menu" id="profile-dropdown-menu"></div>
          </div>
        </div>
      </div>
      <!-- Hidden file input for opening .reto -->
      <input type="file" id="reto-file-input" accept=".reto,.zip" style="display: none;" />
    `;

    this.bindEvents();
    this.updateProjectDetails();
  }

  bindEvents() {
    // Dropdown Tệp, Chỉnh sửa & Trợ giúp
    const fileBtn = document.getElementById('btn-menu-file');
    const fileDropdown = document.getElementById('dropdown-file');
    const editBtn = document.getElementById('btn-menu-edit');
    const editDropdown = document.getElementById('dropdown-edit');
    const helpBtn = document.getElementById('btn-menu-help');
    const helpDropdown = document.getElementById('dropdown-help');

    const toggleMenu = (btn, dropdown) => {
      const isShow = dropdown.classList.contains('show');
      document.querySelectorAll('.dropdown-menu').forEach(d => d.classList.remove('show'));
      if (!isShow) {
        dropdown.classList.add('show');
      }
    };

    fileBtn.addEventListener('click', (e) => {
      e.stopPropagation();
      toggleMenu(fileBtn, fileDropdown);
    });

    editBtn.addEventListener('click', (e) => {
      e.stopPropagation();
      toggleMenu(editBtn, editDropdown);
    });

    helpBtn.addEventListener('click', (e) => {
      e.stopPropagation();
      toggleMenu(helpBtn, helpDropdown);
    });

    document.addEventListener('click', () => {
      document.querySelectorAll('.dropdown-menu').forEach(d => d.classList.remove('show'));
    });

    // Menu Actions
    document.getElementById('menu-item-new').addEventListener('click', () => {
      if (this.onNewProject) this.onNewProject();
    });

    document.getElementById('menu-item-open').addEventListener('click', () => {
      document.getElementById('reto-file-input').click();
    });

    document.getElementById('reto-file-input').addEventListener('change', (e) => {
      const file = e.target.files[0];
      if (file && this.onOpenProject) {
        this.onOpenProject(file);
      }
      e.target.value = '';
    });

    document.getElementById('menu-item-save').addEventListener('click', () => {
      if (this.onSaveProject) this.onSaveProject();
    });

    // Cloud Projects
    const handleCloudClick = () => {
      if (this.onOpenCloud) this.onOpenCloud();
    };

    const cloudMenuItem = document.getElementById('menu-item-cloud');
    if (cloudMenuItem) cloudMenuItem.addEventListener('click', handleCloudClick);

    const cloudNavBtn = document.getElementById('btn-cloud-nav');
    if (cloudNavBtn) cloudNavBtn.addEventListener('click', handleCloudClick);

    // Profile Dropdown Toggle & Click Outside
    const profileWrapper = document.getElementById('profile-dropdown-wrapper');
    const profileTrigger = document.getElementById('btn-profile-trigger');

    if (profileTrigger && profileWrapper) {
      profileTrigger.addEventListener('click', (e) => {
        e.stopPropagation();
        if (!this.currentUser) {
          window.location.href = supabaseService.getLoginUrl();
          return;
        }
        profileWrapper.classList.toggle('open');
      });
    }

    document.addEventListener('click', (e) => {
      if (profileWrapper && !profileWrapper.contains(e.target)) {
        profileWrapper.classList.remove('open');
      }
    });

    const helpPythonGuideBtn = document.getElementById('menu-item-help-python-guide');
    if (helpPythonGuideBtn) {
      helpPythonGuideBtn.addEventListener('click', () => {
        if (this.onOpenPythonGuide) {
          this.onOpenPythonGuide();
        } else {
          window.open('/python-guide.html', '_blank');
        }
      });
    }

    document.getElementById('menu-item-help-about').addEventListener('click', () => {
      alert('RETOLOGIX Studio (RETOBLOCK V1.0)\nMôi trường lập trình STEAM cho Robot RETOCAR-STARTER (ESP32).\nTính năng: Live Mode qua RAM, BLE Fast OTA (MTU 512B, DLE).');
    });

    // Rename Inline
    const nameBox = document.getElementById('project-name-box');
    const nameText = document.getElementById('project-name-text');
    const nameInput = document.getElementById('project-name-input');

    nameBox.addEventListener('click', () => {
      nameText.style.display = 'none';
      nameInput.style.display = 'inline-block';
      nameInput.value = this.projectManager.getProjectName();
      nameInput.focus();
      nameInput.select();
    });

    const commitRename = () => {
      const val = nameInput.value.trim();
      if (val) {
        this.projectManager.setProjectName(val);
        nameText.textContent = val;
      }
      nameInput.style.display = 'none';
      nameText.style.display = 'inline-block';
    };

    nameInput.addEventListener('keydown', (e) => {
      if (e.key === 'Enter') commitRename();
      if (e.key === 'Escape') {
        nameInput.style.display = 'none';
        nameText.style.display = 'inline-block';
      }
    });
    nameInput.addEventListener('blur', commitRename);


    // BLE Pill Button
    document.getElementById('btn-ble-status').addEventListener('click', () => {
      if (this.onOpenBleModal) this.onOpenBleModal();
    });

    // Run / Stop
    document.getElementById('btn-run-code').addEventListener('click', () => {
      if (this.onRun) this.onRun();
    });

    document.getElementById('btn-stop-code').addEventListener('click', () => {
      if (this.onStop) this.onStop();
    });
  }

  updateProjectDetails() {
    const name = this.projectManager.getProjectName();
    const mode = this.projectManager.getLanguageMode();

    document.getElementById('project-name-text').textContent = name;
    const badge = document.getElementById('mode-badge');
    badge.textContent = mode.toUpperCase();
    badge.className = `mode-badge ${mode}`;
  }

  setUnsavedDot(isDirty) {
    const dot = document.getElementById('unsaved-dot');
    if (dot) {
      if (isDirty) dot.classList.add('visible');
      else dot.classList.remove('visible');
    }
  }

  updateBleState(status, deviceName = '') {
    const pill = document.getElementById('btn-ble-status');
    const text = document.getElementById('ble-text');
    if (!pill || !text) return;

    pill.className = `ble-pill-btn ${status}`;
    if (status === 'connected') {
      text.textContent = deviceName || 'RETOCAR';
    } else if (status === 'connecting') {
      text.textContent = 'Đang ghép nối...';
    } else if (status === 'lost') {
      text.textContent = 'Mất tín hiệu!';
    } else {
      text.textContent = 'Chưa kết nối';
    }
  }

  setExecutionState(state, progress = 0) {
    const runBtn = document.getElementById('btn-run-code');
    const runText = document.getElementById('run-text');
    if (!runBtn || !runText) return;

    if (state === 'uploading') {
      runBtn.className = 'btn-run uploading';
      runText.innerHTML = `<span class="run-text-full">ĐANG NẠP (${progress}%)...</span><span class="run-text-short">${progress}%</span>`;
      runBtn.disabled = true;
    } else if (state === 'running') {
      runBtn.className = 'btn-run running';
      runText.innerHTML = '<span class="run-text-full">RUNNING...</span><span class="run-text-short">RUNNING</span>';
      runBtn.disabled = true;
    } else {
      runBtn.className = 'btn-run';
      runText.innerHTML = '<span class="run-text-full">RUN CODE</span><span class="run-text-short">RUN</span>';
      runBtn.disabled = false;
    }
  }

  updateUserState(user, quotaCount = 0) {
    this.currentUser = user;
    const quotaPill = document.getElementById('cloud-quota-pill');
    const profileWrapper = document.getElementById('profile-dropdown-wrapper');
    const profileTrigger = document.getElementById('btn-profile-trigger');
    const profileMenu = document.getElementById('profile-dropdown-menu');

    if (quotaPill) {
      if (user) {
        quotaPill.textContent = `${quotaCount}/10`;
        quotaPill.className = `cloud-quota-pill ${quotaCount >= 10 ? 'full' : ''}`;
      } else {
        quotaPill.textContent = 'Offline';
        quotaPill.className = 'cloud-quota-pill offline';
      }
    }

    if (!profileWrapper || !profileTrigger || !profileMenu) return;

    if (user) {
      const displayName = user.user_metadata?.full_name || (user.email ? user.email.split('@')[0] : 'Học viên');
      const email = user.email || '';
      const initialChar = (displayName.trim()[0] || 'U').toUpperCase();
      const rawRole = (user.role || user.user_metadata?.role || '').toLowerCase();
      const isAdmin = rawRole === 'admin' || rawRole === 'quản trị viên';
      const roleBadgeText = isAdmin ? 'QUẢN TRỊ VIÊN' : 'HỌC VIÊN';
      const badgeClass = isAdmin ? 'profile-dd-badge admin' : 'profile-dd-badge';

      profileTrigger.className = 'profile-pill-btn';
      profileTrigger.title = `Tài khoản: ${displayName} (${email})`;
      profileTrigger.innerHTML = `
        <span class="profile-pill-name">${this.escapeHtml(displayName)}</span>
        <div class="profile-pill-avatar">${initialChar}</div>
        <svg class="profile-pill-chevron" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
          <path d="m6 9 6 6 6-6"/>
        </svg>
      `;

      const retozoneUrl = getRetozoneUrl();
      const retolearnUrl = getRetolearnUrl();
      profileMenu.innerHTML = `
        <div class="profile-dd-header">
          <div class="profile-dd-name">${this.escapeHtml(displayName)}</div>
          <div class="profile-dd-email">${this.escapeHtml(email)}</div>
          <span class="${badgeClass}">${roleBadgeText}</span>
        </div>
        <div class="profile-dd-divider"></div>
        <a class="profile-dd-item" href="${retozoneUrl}" target="_blank" rel="noopener noreferrer" id="btn-goto-retozone">
          <span>Về Cổng Chính (RETOZONE)</span>
          <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"/>
            <polyline points="15 3 21 3 21 9"/>
            <line x1="10" y1="14" x2="21" y2="3"/>
          </svg>
        </a>
        <a class="profile-dd-item" href="${retolearnUrl}" target="_blank" rel="noopener noreferrer" id="btn-goto-retolearn">
          <span>Học Viện (RETOLEARN)</span>
          <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"/>
            <polyline points="15 3 21 3 21 9"/>
            <line x1="10" y1="14" x2="21" y2="3"/>
          </svg>
        </a>
        <div class="profile-dd-divider"></div>
        <button class="profile-dd-item logout" type="button" id="btn-profile-logout">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/>
            <polyline points="16 17 21 12 16 7"/>
            <line x1="21" y1="12" x2="9" y2="12"/>
          </svg>
          <span>Đăng Xuất</span>
        </button>
      `;

      const logoutBtn = document.getElementById('btn-profile-logout');
      if (logoutBtn) {
        logoutBtn.addEventListener('click', async (e) => {
          e.stopPropagation();
          profileWrapper.classList.remove('open');
          try {
            await supabaseService.signOut();
          } catch (err) {
            console.error('[RETOBLOCK] Sign out error:', err);
          }
        });
      }
    } else {
      profileTrigger.className = 'profile-pill-btn offline';
      profileTrigger.title = 'Tài khoản ngoại tuyến - Bấm để đăng nhập';
      profileTrigger.innerHTML = `
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>
        <span class="profile-pill-name" id="profile-pill-name">Đăng nhập</span>
      `;
      profileMenu.innerHTML = '';
      profileWrapper.classList.remove('open');
    }
  }

  escapeHtml(str) {
    if (!str) return '';
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }
}
